<template>
  <div
    v-if="contacts && contacts.contactsByRole && Object.values(contacts.contactsByRole).length"
    class="position-relative"
  >
    <div class="contacts">
      <template v-for="profile in contacts.contactsByRole" :key="profile.id">
        <ul class="profile">
          <li class="profile__name">{{ profile.role.name }}</li>
          <ul class="profile__users">
            <li v-for="contact in profile.users[0]" :key="contact.id">
              <button class="profile__userName" @click="openContact(contact, profile?.role?.name)">
                {{ contact.studeaUser.fullName }}
              </button>
            </li>
          </ul>
        </ul>
      </template>
    </div>
    <BlockLoader :loading="loading" />
    <GenericModalComponent
      :opened="opened"
      :title="$tc('training.contact.detail.title', { name: currentContact?.studeaUser?.fullName })"
      @hidden="handleModalOpened(false)"
    >
      <template v-slot:content>
        <template v-for="element in contactInfoKeys" :key="element.data">
          <div class="row item">
            <div class="col-2">{{ element.title }} :</div>
            <div class="col-9 fw-bold">{{ element.data ? element.data : "--" }}</div>
          </div>
        </template>
      </template>
    </GenericModalComponent>
  </div>
  <EmptyBlock :text="$t('registration.insee_company.empty_contact')" />
</template>

<script>
import BlockLoader from "@/components/blocks/BlockLoader.vue";
import GenericModalComponent from "@/components/modal/GenericModalComponent.vue";
import { i18n } from "@/i18n";
import EmptyBlock from "@/components/blocks/EmptyBlock.vue";

export default {
  name: "RegistrationCompanyContactTabComponent",
  components: { EmptyBlock, GenericModalComponent, BlockLoader },
  props: {
    contacts: {
      type: Object,
      required: true,
    },
    loading: {
      type: Boolean,
      required: true,
    },
  },
  emits: ["removeContact"],
  data() {
    return {
      opened: false,
      currentContact: null,
      currentRole: null,
    };
  },
  computed: {
    contactInfoKeys() {
      return [
        { data: this.currentContact?.studeaUser?.firstName, title: i18n.global.t("firstName") },
        { data: this.currentContact?.studeaUser?.lastName, title: i18n.global.t("lastName") },
        { data: this.currentContact?.studeaUser?.function, title: i18n.global.t("registration.function") },
        { data: this.currentContact?.studeaUser?.email, title: i18n.global.t("email") },
        { data: this.currentContact?.studeaUser?.mobile, title: i18n.global.t("mobile") },
        { data: this.currentRole, title: i18n.global.tc("admin.role.title", 1) },
      ];
    },
  },
  methods: {
    handleModalOpened(open) {
      this.opened = open;
    },

    openContact(contact, role) {
      this.currentContact = contact;
      this.currentRole = role;
      this.handleModalOpened(true);
    },
  },
};
</script>

<style lang="scss" scoped>
.contacts {
  .profile {
    list-style-type: none;
    padding: 0;

    &__name {
      font-weight: 500;
      font-size: 16px;
      margin-bottom: 8px;
    }

    &__users {
      list-style-type: none;
      padding: 0;
      display: flex;
    }

    &__userName {
      display: inline-flex;
      align-items: center;
      justify-content: center;
      text-align: center;
      background: var(--primary-color);
      padding: 7px 15px;
      border-radius: $radius;
      color: $white;
      margin-right: 15px;
      font-size: 14px;
      line-height: 1;
      border: none;
    }
  }

  .profile + .profile {
    .profile__name {
      border-top: 1px dashed $m_color_6;
      padding: 15px 0 0 0;
    }
  }
}

.position-relative {
  min-height: 300px;
}

.item {
  padding: 10px 0;
}

.item + .item {
  border-top: 1px dotted $light-grey;
}
</style>
